import {LocaleDomainService} from "../../../domain/locale/services/locale/locale.domain-service";
import {NavigationManager} from "../../../core/managers/navigation-manager";
import {LanguageViewModel} from "../../../domain/locale/models/language/language.view-model";
import {LanguageDomainModel} from "../../../domain/locale/models/language/language.domain-model";
import {BaseLinkModel} from "../../../infrastructure/models/link/base-link-model";
import {DEFAULT_CULTURE_NAME} from "../../../core/app/consts";
import {RouterController} from "../../../core/components/router/router-controller";
import {RouteModel} from "../../../core/components/router/models/route-model";


export class LanguageViewModelList extends Array<LanguageViewModel> {

  static injectables = [LocaleDomainService, NavigationManager, RouterController];

  constructor(localeDomainService: LocaleDomainService, navigationManager: NavigationManager, routerController: RouterController) {
    super();

    this.localeDomainService = localeDomainService;

    if (!localeDomainService.languages) {
      return;
    }

    const languages: Array<LanguageViewModel> = localeDomainService.languages.map((lang: LanguageDomainModel) => new LanguageViewModel(lang, navigationManager));
    const currentLinkModel: BaseLinkModel = navigationManager.currentLinkModel?.clone();

    if (!currentLinkModel) {
      return;
    }

    const routeModel: RouteModel = routerController.findRouteByName(currentLinkModel.name);
    const items = !currentLinkModel ? languages : languages.map((lang: LanguageViewModel) => {
      const displayLanguageParam: String = lang.cultureName === DEFAULT_CULTURE_NAME ? '' : '/' + lang.displayName;
      const baseUrl: String = navigationManager.createUrl(routeModel.config.path, currentLinkModel);

      lang.linkModel.url = displayLanguageParam + baseUrl;

      return lang;
    });

    const filteredLanguages = this._filterHiddenLanguages(items);

    this.push(...filteredLanguages.sortByKeys(['displayName']));
  }

  _filterHiddenLanguages(languages: Array<LanguageViewModel>): Array<LanguageViewModel> {
    let filteredLanguages = languages;

    if(!this.localeDomainService.locale || !this.localeDomainService.locale.userCountryModel) {
      return languages;
    }

    const hideLanguages: Array<Number> = this.localeDomainService.locale.userCountryModel.hideLanguages;

    if(hideLanguages && hideLanguages.length > 0){
      filteredLanguages = languages.filter((language: LanguageViewModel) => !hideLanguages.includes(language.id));
    }

    return filteredLanguages;
  }

}
